<template>
    <div>
        <!--首页-->
        <div id="bodycontent" :class="showIndex ? 'bodycontent1' : 'bodycontent2'">
            <div class="wechat">
                <!-- 顶部互动模块 -->
                <div class="basicData tb">
                    <div class="location">
                        <div
                            style="width: 34%;
							border: 1px solid rgb(81, 236, 91);
							border-radius: 25px;
							height:23px;
							background-color: rgb(245, 251, 255);
							padding-left: 27px;
							position: relative;"
                            @click="showPositionPannel = !showPositionPannel"
                        >
                            <!-- <h3>{{streetName}}</h3> -->
                            <h3>{{ shortStreetName }}</h3>
                            <span class="streetnameSpan"></span>
                            <span v-if="false" @click.stop="showNoticeMask = !showNoticeMask" class="notice"></span>
                        </div>
                        <!-- showUserPosition -->
                        <div v-show="true" class="userposition_div" v-on:click="getNewLocation()">
                            <img class="userposition_div_img" />
                            {{ userPosition.street }}
                        </div>
                        <div class="copyRight">{{ wxUnit }}</div>
                    </div>
                    <div>
                        <span v-on:click="showpotograph = !showpotograph" class="camera"></span>
                        <span @click="clear()" id="clear" class="clearSelect">治理</span>
                    </div>
                    <div class="circleChart flex flex-center flex-dir justily-c" id="circleChart">
                        <div class="canvasText">
                            <canvas id="myCanvas" width="212" height="212" data-page-switch>您的浏览器不支持 HTML5 canvas 标签。</canvas>
                            <div>
                                <p class="circleChartTitle">{{ treeType }}飘絮指数</p>
                                <p class="chartValue" :style="'color:' + levelcolor">{{ indexvalue }}</p>
                                <p class="level" :style="'color:' + levelcolor">{{ level == '无' ? '对出行无影响' : level == '轻度' ? '对出行基本无影响' : level }}</p>
                                <p class="publishTime">{{ publishTime }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="discription" v-html="discriptionDom">
                        <!-- <span class="icon"></span> -->
                        <!-- 今天北极阁2号附近飘絮较少，对健康基本没有影响，可以出门走走哦! -->
                        <!-- <span class="stretchBtn"></span> -->
                    </div>
                    <div class="appraise">
                        <ul>
                            <li id="correct" @click="correctAction" :class="correctSelected ? 'gSelect' : 'gunSelect'">准{{ correct }}</li>
                            <li id="uncorrect" @click="unCorrectAction" :class="unCorrectSelected ? 'bSelect' : 'bunSelect'">不准{{ uncorrect }}</li>
                        </ul>
                        <div class="jump_div" v-if="showJump">
                            <span class="jump_div_ss">{{ showJumpSs }}</span>
                            <span class="jump_div_text">秒后将切换至{{ showJumpCiyt }}</span>
                            <span class="jump_div_go" v-on:click="gotoForecastCity()">立刻前往</span>
                        </div>
                    </div>
                </div>
                <div class="positionPannel" v-if="showPositionPannel">
                    <div class="position">
                        <span id="backspan" class="backspan" @click="showPositionPannel = !showPositionPannel"></span>
                        <input v-model="upLoadstreetName" placeholder="输入街道" />
                    </div>
                    <div class="streetFitContent">
                        <ul>
                            <li style="height:54px"></li>
                            <li v-show="streetFit.length == 0 ? true : false"></li>
                            <li v-for="obj in streetFit" v-on:click="resetPosition(obj)">
                                <label for="obj.name">{{ obj.name }}</label>
                                <label class="stree_label">{{ obj.address }}</label>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 曲线图表模块 -->
                <div class="lineChart">
                    <div class="lineChartTitle">
                        <h3 class>飘絮指数</h3>
                        <ul>
                            <li>无</li>
                            <li>轻</li>
                            <li>中</li>
                            <li>重</li>
                        </ul>
                    </div>
                    <div class="levelIconWrap" style="display:block">
                        <span class="levelIcon-0"></span>
                        <span class="levelIcon-1"></span>
                        <span class="levelIcon-2"></span>
                        <span class="levelIcon-3"></span>
                    </div>
                    <div class="lineChartWarp" id="lineChartWarp">
                        <!-- <div class="lineChartWarp-div"> -->
                        <div class="lineChartContent" id="lineChartContent"></div>
                        <div class="chartMask"></div>
                        <!-- </div> -->
                    </div>
                </div>
                <!-- 地图交换模块 -->
                <div class="tb2" style="position: relative;">
                    <ul class="treeTypeDiv">
                        <li v-on:click="addHeadMap(obj.type)" :class="{ on: treeOn === obj.type }" v-for="obj in treeTypes">{{ obj.name }}</li>
                    </ul>
                    <div id="mapoutside" class="map1">
                        <div id="map" class="mapcontain" style="z-index:-1"></div>
                        <div id="leafletmap" class="mapcontain"></div>
                    </div>
                    <div class="mapHander">
                        <ul>
                            <li id="layer" :class="showLayer ? 'layerSelect' : 'layerSelect unopenPic'" @click="showLayer = !showLayer">治理路段</li>
                            <li id="view" @click="showImgPoi = !showImgPoi" :class="showImgPoi ? 'vunSelect' : 'vunSelect unopenPic'">实景</li>
                            <li @click="zoom()" id="zoom" class="zunSelect">全屏</li>
                            <li @click="pan()" id="location" class="lunSelect">定位</li>
                        </ul>
                    </div>
                    <div class="timeLine">
                        <span v-on:click="playheadMap()" style="position:absolute;bottom:0px;left:0px;width:45px;height:65px;z-index:99999;"></span>
                        <span :class="playStatue ? 'playBtn stopBtn' : 'playBtn startBtn'"></span>
                        <div class="line">
                            <div>
                                <!-- <ul :style="timeIndex>4?'left:-'+timeIndex*30+'px':''"> -->
                                <ul>
                                    <li :class="timeIndex == index ? 'active' : timeIndex > index ? 'pass' : ''" :headmaptime="time" v-for="(time, index) in timeData">
                                        <span class="data">{{ time.forecasttime.substr(6, 2) }}日</span>
                                        <em>
                                            <i></i>
                                        </em>
                                        <span>{{ time.forecasttime.substr(8, 2) }}:00</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="mask" v-show="showNoticeMask" @click="showNoticeMask = !showNoticeMask">
                        <div class="hardIndex">
                            <a class="unCorrect-close"></a>
                            <div>
                                <div>
                                    <p>
                                        今天飘絮指数
                                        <span style="color:red;display:inline-block;padding:0 5px;font-size:18px;">重度</span>道路
                                    </p>
                                    <span style="color:#666;display:inline-block;padding:0 50px;">过敏患者请尽量减少外出, 外出时要注意防护, 戴口罩或防护镜等。</span>
                                </div>
                            </div>
                            <ul>
                                <li v-for="obj in hardIndexStreet">
                                    <span>{{ obj.streetName }}</span>
                                    <span>飘絮指数:</span>
                                    <span style="color:red;">{{ obj.level }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="mask" v-show="showUNCorrectMask" @click="showUNCorrectMask = !showUNCorrectMask">
                        <div class="unCorrect">
                            <a class="unCorrect-close"></a>
                            <div>
                                <div>
                                    <p>今天的飘絮多吗？</p>
                                    <span class="maxUncorrect">有{{ maxUncorrect }}的用户认为</span>
                                    <span class="maxLevel">{{ maxLevel }}</span>
                                </div>
                            </div>
                            <ul>
                                <li v-for="obj in unCorrectLevel" @click="unCorrectListAction(obj.type)">
                                    <span>{{ obj.level }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="gpsTip">请确保开启定位服务，否则无法提供精准数据</div> -->
            <div class="dialog-modal">
                <div class="discriptionTip-dialog">
                    <h4>温馨提示</h4>
                    <p>{{ liveDescript }}</p>
                    <span class="discriptionTip-dialog-closer">确定</span>
                </div>
            </div>
        </div>

        <!--图片详情页面-->
        <div id="potoDiv" v-show="showpoto" class="showpoto_div">
            <span v-on:click="showpoto = !showpoto" class="backspan"></span>
            <div class="picture_div">
                <div class="swiper-container">
                    <div class="swiper-wrapper" id="swiper-wrapper">
                        <div class="swiper-slide">
                            <img @error="imageError" @load="imageLoaded" @click="showBigImg(basePath + '/webfile/uploadphoto/' + listImg[picIndex].url)" v-if="listImg.length != 0" :src="listImg.length != 0 ? basePath + '/webfile/uploadphoto/' + listImg[picIndex].url : ''" />
                            <div class="loader" v-if="isImgLoading">
                                <img style="height:60px;width:60px;" class="loading" src="./images/loading.png" alt />
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination swiper-pagination-white"></div>
                </div>
                <p class="piaoxuLevel" style="text-align:center;width: 100%;" v-if="showNetTip">数据加载失败！</p>
                <p v-bind:class="['piaoxuLevel', pxClass]" v-else>
                    <span class="piaoxuLevel-title">飘絮等级：</span>
                    <span class="piaoxuLevel-content">{{ pxLevel == '无' ? pxLevel : pxLevel }}</span>
                </p>
                <div class="image-list">
                    <div>
                        <ul>
                            <li v-on:click="picIndex = index" :class="index == picIndex ? 'footdiv footdiv_active' : 'footdiv'" v-for="(str, index) in listImg">
                                <img :src="basePath + '/webfile/uploadphoto/' + str.url" @load="imglistLoaded" alt style="height:100%;width:100%;" />
                                <span class="imgLoadingSpan"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="BigImgCont" v-show="showBigImgCon" @click="showBigImgCon = !showBigImgCon">
                <img id="bigImg" :src="bigImgSrc" alt />
            </div>
        </div>
        <!--地图定位信息-->
        <!-- <iframe id="geoPage" width=0 height=0 frameborder=0  style="display:none;" scrolling="no"
		    src="https://apis.map.qq.com/tools/geolocation?key=FHIBZ-B7P3U-XLVV7-B4J54-H42CE-TDBSP&referer=myapp">
        </iframe>-->

        <!--拍照上传页面-->
        <div id="potographDiv" v-show="showpotograph" class="showpoto_div" style="background-color:#eee">
            <form enctype="multipart/form-data" id="photo-form" v-if="showpotograph">
                <div class="loader" v-if="isImgUpLoading">
                    <img style="height:60px;width:60px;" class="loading" src="./images/loading.png" alt />
                    <div class="loadText">正在上传</div>
                </div>
                <div class="locations">
                    <span v-on:click="showpotograph = !showpotograph" id="backspan" class="backspan"></span>
                    <span class="location-title">道路名称</span>
                    <label class="current-street">
                        <span class="locationIcon"></span>
                        <input id="streetName_input" type="text" name="streetName" v-model="upLoadstreetName" placeholder="输入街道" />
                        <input id="streetLon_input" name="streetLon" style="display:none" :value="streetLon" />
                        <input id="streetLat_input" name="streetLat" style="display:none" :value="streetLat" />
                    </label>
                    <span class="more-btn" v-on:click="isShowAreaSelect = true"></span>
                </div>
                <div class="streetFitContent" v-show="isStreetFitContentShow">
                    <ul>
                        <li style="height:54px"></li>
                        <li v-show="streetFit.length == 0 ? true : false"></li>
                        <li v-for="obj in streetFit" v-on:click="selectArea(obj)">
                            <label for="obj.Name">{{ obj.n }}</label>
                        </li>
                    </ul>
                </div>
                <div class="add-photo">
                    <h4 class="add-photo-title">添加照片</h4>
                    <div class="upload-area">
                        <ul class="uploadList">
                            <li v-for="(obj, index) in uploadImgCountObj">
                                <span class="img-closer" @click="deleteImg(index, obj.imgid)"></span>
                                <img :id="obj.imgid" :src="camera" class="uploadImg" @click="uploadImg(obj)" />
                                <input :id="obj.fileid" type="file" accept="image/*" name="file" v-on:change="uploadChange(obj.fileid, obj.imgid)" />
                            </li>
                        </ul>
                    </div>
                    <canvas id="compressImg" style="display:none"></canvas>
                </div>
                <div class="piaoxu-level">
                    <h4 class="piaoxu-level-title">飘絮等级</h4>
                    <div class="piaoxu-level-select">
                        <ul class="piaoxu-level-items">
                            <li v-for="obj in piaoxuLevelObj" :class="piaoxuAcive == obj.id ? 'active' : ''" v-on:click="piaoxuAcive = obj.id">
                                <label :for="obj.id">
                                    {{ obj.label }}
                                    <input type="radio" :id="obj.id" :name="obj.name" :value="obj.value" class="px-radio" :checked="piaoxuAcive == obj.id ? true : false" />
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <button type="button" class="submit-btn" v-on:click="photographSumbit()">上传</button>
                <div class="dialog-modal" :style="isShowAreaSelect ? 'display:block' : 'display:none'">
                    <div class="choice-area-dialog dialog-show">
                        <h4 class="dialog-title">
                            所在地区
                            <span class="close-btn" v-on:click="isShowAreaSelect = false"></span>
                        </h4>
                        <ul class="menu-tab-items">
                            <li id="city">{{ city }}</li>
                            <li id="county" class="active selectable">{{ county }}</li>
                            <li id="street" :class="upLoadstreetName == '' ? 'selectable' : 'active selectable'">{{ upLoadstreetName == '' ? '道路名称' : upLoadstreetName }}</li>
                        </ul>
                        <ul v-show="areaType == 'county'" class="menu-tab countyList">
                            <li v-on:click="county = obj.county" v-for="obj in countyDatas" :class="county == obj.county ? 'active' : ''">{{ obj.county }}</li>
                        </ul>
                        <ul v-for="obj in countyDatas" :class="county == obj.county ? 'menu-tab street' : 'menu-tab street streetList'">
                            <li v-on:click="selectArea(street)" :class="upLoadstreetName == street.n ? 'active' : ''" v-for="(street, index) in obj.list">
                                <label :for="street.Id">
                                    {{ street.n }}
                                    <input type="radio" :id="street.Id" name="streetId" :value="street.Id" class="photo-street" />
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dialog-modal">
                    <div :class="'submitTip-dialog ' + upLoadStatus">
                        <p class="submitTip-dialog-text">{{ upLoadTip }}</p>
                        <button type="button" class="submitTip-dialog-closer" v-on:click="closeDialog()">OK</button>
                    </div>
                </div>
            </form>
        </div>
        <div id="container" style="visibility: hidden;"></div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import './css/common.css'
import './css/photograph.css'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import Highcharts from 'highcharts'
import hammer from '../../util/hammer.min.js'
import EXIF from '../../util/exif.js'
import base64Img from '../../util/base64Img.js'
import drawGaugeCanvas from '../../util/drawGaugeCanvas.js'
import drawHighChartLine from '../../util/drawHighChartLine.js'
import gmap from './js/gmap.js'
import lmap from './js/lmap.js'
import gcoord from 'gcoord'
import coordtransform from 'coordtransform'
// import './js/jquery.nicescroll.min.js';

export default {
    computed: {
        ...mapState({
            clickPositionObj: state => state.clickPositionObj,
            userPosition: state => state.userPosition,
            failLiveData: state => state.failLiveData,
            unCorrectLevel: state => state.unCorrectLevel,
            initStreesInfo: state => state.initStreesInfo,
            piaoxuLevelObj: state => state.piaoxuLevelObj,
            uploadImgCountObj: state => state.uploadImgCountObj
        }),
        // 道路虚线接口的时间参数
        handleRoadTime() {
            let res = '';
            if (this.headmaptime instanceof Object) {
                const { forecasttime } = this.headmaptime;
                if (typeof forecasttime === 'string') {
                    const month = Number(forecasttime.slice(4, 6));
                    const day = Number(forecasttime.slice(6, 8));
                    res = `${month}月${day}日`;
                }
            }
            return res;
        }
    },
    data() {
        return {
            // basePath:'http://www.linkcm.com/national-service-js', //服务器路径
            basePath: '/national-service-js', //本地路径
            citycode: null, //城市编码
            winWidth: 0,
            winHight: 0,
            screenHeight: 0,
            forecastTime: '',
            liveTime: '',

            treeType: '',
            treeOn: 'all',
            wxTitle: '', //标题
            wxUnit: '', //单位
            treeTypes: [], //树种
            curTreeType: 'all', //当前选择的树种

            /*可变参数*/
            city: '南京市', //拍照上传---默认城市
            county: '玄武区', //拍照上传---默认区
            streetName: '', //拍照上传---默认街道名称
            shortStreetName: '', //首页显示---默认街道名称
            gaodelocation: null,

            /*首页参数*/
            showUserPosition: false,
            showJump: false, //显示跳转提示
            showJumpSs: 9,
            showJumpCiyt: '',
            streetId: '',
            publishTime: '',
            level: '',
            indexvalue: '',
            levelcolor: '',
            discriptionDom: '',
            maxUncorrect: '100%',
            maxLevel: '',
            correctSelected: false,
            unCorrectSelected: false,
            correct: '',
            uncorrect: '',
            hardIndexStreet: [
                {
                    streetName: '童卫路',
                    level: '78'
                },
                {
                    streetName: '中山门外大街',
                    level: '79'
                },
                {
                    streetName: '板仓街',
                    level: '89'
                },
                {
                    streetName: '中山东路',
                    level: '65'
                },
                {
                    streetName: '黄埔路',
                    level: '78'
                },
                {
                    streetName: '解放路',
                    level: '79'
                },
                {
                    streetName: '瑞金路',
                    level: '89'
                },
                {
                    streetName: '珠江路',
                    level: '65'
                },
                {
                    streetName: '丹凤街',
                    level: '79'
                },
                {
                    streetName: '北京东路',
                    level: '89'
                },
                {
                    streetName: '中央路',
                    level: '65'
                },
                {
                    streetName: '红山路',
                    level: '78'
                },
                {
                    streetName: '长江路',
                    level: '79'
                },
                {
                    streetName: '汉府街',
                    level: '89'
                },
                {
                    streetName: '蒋王庙街',
                    level: '65'
                }
            ],
            discriptionTipDialog: {},
            liveStatus: 0,
            showUNCorrectMask: false,
            liveDescript: {},
            showPositionPannel: false,
            showNoticeMask: false,
            /*
            地图参数
            */
            isLocation: true,
            lonlatLayer: null, //定位图标
            clickPoiLayer: null, //点击地图图标
            userCanvas: false,
            mapzoom: -1,
            showMinPop: false,
            showMaxPop: true,
            showpoto: false,
            showpotograph: false,
            showIndex: true,
            showNetTip: false,
            showImgPoi: false, //显示地图上的图片
            showLayer: true, // 显示地图上的道路
            /*
            时间轴相关参数
            */
            timeArray: [],
            timeIndex: 0,
            timeLength: 0,
            timeData: [],
            idAndTime: '',
            HMlayer: {},
            preLonLat: [],
            smallphotodata: [], //缩略图的图片数据
            infoWinData: [],
            photodata: {}, //图片详情页的图片数据
            smallphotodatalayergroup: null,
            smallphotodatalayerContentgroup: null,
            headmaptime: '',
            playTime: null,
            playStatue: false,
            /*
            图片详情页面参数
            */
            isImgLoading: true,
            //isImgDataLoading:true,
            swiper: null,
            hammer: null,
            pxLevel: '',
            pxClass: '',
            listImg: [],
            imgLength: 0,
            picIndex: 0,
            bigImgSrc: '',
            scaleLevel: 0,
            showBigImgCon: false,
            /*拍照上传页面参数
             */
            upLoadstreetName: '',
            streetLat: '32.03816716484425',
            streetLon: '118.7890681974245',
            areaType: 'county',
            upLoadTip: '',
            upLoadStatus: '',
            camera: '',
            piaoxuAcive: 'none',
            isPass: false,
            isImgUpLoading: false,
            isStreetFitContentShow: false,
            hasSelectStreet: false,
            isShowAreaSelect: false,
            compressImg: [],
            countyDatas: [], //拍照上传道路数据
            streetFit: [],

            handleRoad: [], // 道路
        }
    },
    created: function() {
        var vm = this
        var _citycode = vm.getQueryString('city')
        vm.citycode = _citycode == null ? '320100' : _citycode
        //console.log(vm.citycode)
        //初始化首页、拍照上传默认道路
        this.city = this.initStreesInfo[vm.citycode].city
        this.county = this.initStreesInfo[vm.citycode].county
        this.streetName = this.initStreesInfo[vm.citycode].streetName
        this.shortStreetName = this.initStreesInfo[vm.citycode].shortStreetName
        this.treeTypes = this.initStreesInfo[vm.citycode].treeTypes

        //单位、标题
        var inscribeUrl = vm.basePath + '/user/inscribe?cityCode=' + vm.citycode + '&r=' + Math.random()
        vm.$http.get(inscribeUrl).then(response => {
            response = response.body
            vm.wxTitle = response[0].wxTitle //标题
            vm.wxUnit = response[0].wxUnit //单位
        })

        let forecastTimeUrl = this.basePath + '/user/getForecastTime?cityCode=' + vm.citycode
        this.$http.get(forecastTimeUrl).then(response => {
            this.forecastTime = response.body.data;
        })

        let liveTimeUrl = this.basePath + '/user/getLiveTime?cityCode=' + vm.citycode
        this.$http.get(liveTimeUrl).then(response => {
            this.liveTime = response.body.data
        })

        setTimeout(function() {
            vm.camera = base64Img['camera']

            var smallPhotoUrl = vm.basePath + '/webfile/smallphotodata/' + vm.citycode + '/wxsmallphotodata.json?r=' + Math.random()
            //	var smallPhotoUrl = "http://localhost:8099/smallphotodata/320100/wxsmallphotodata.json";
            vm.$http.get(smallPhotoUrl).then(response => {
                response = response.body
                vm.smallphotodata = response
            })
            var countyDatasUrl = vm.basePath + '/webfile/jsonDataFile_new/' + vm.citycode + '/countyDatas.json?r=' + Math.random()
            vm.$http.get(countyDatasUrl).then(response => {
                response = response.body
                vm.countyDatas = response
            })
        }, 3000)
    },
    watch: {
        forecastTime() {
            var vm = this
            var timeUrl = vm.basePath + '/user/forecastDataTimes?cityCode=' + vm.citycode + '&r=' + Math.random() + '&forecastTime=' + this.forecastTime
            vm.$http.get(timeUrl).then(response => {
                response = response.body
                vm.timeData = response
            })
        },
        showJump() {
            if (this.showJump) {
                this.showJumpCiyt = this.initStreesInfo[this.citycode].city
                this.reciprocal()
            }
        },
        showJumpSs() {
            this.reciprocal()
        },
        clickPositionObj() {
            //显示实况、预报数据
            this.streetName = this.clickPositionObj.street
            this.setCookie('FATONG_LONLAT', this.clickPositionObj['lng'] + ';' + this.clickPositionObj['lat'])
            //this.getLiveData(this.clickPositionObj['lng'],this.clickPositionObj['lat'],false);
        },
        showNoticeMask(val) {
            if (val) {
                $('body').css('position', 'fixed')
            } else {
                $('body').css('position', 'static')
            }
        },
        wxTitle() {
            $('title').text(this.wxTitle)
        },
        streetName(val) {
            if (this.winWidth > 500) {
                this.shortStreetName = val
                return
            }
            var street = val.split('')
            if (street.length > 5) {
                this.shortStreetName = val.substring(0, 6) + '...'
            } else {
                this.shortStreetName = val
            }
        },
        'userPosition.street'(val) {
            this.shortStreetName = val;
        },
        timeData() {
            var bodyWidth = $('body').width()
            var lineWidth = bodyWidth - 33
            $('.line').width(lineWidth)
            this.timeLength = this.timeData.length
            $('.line ul').width(this.timeLength * 38)
            this.headmaptime = this.timeData[this.timeIndex]
        },
        smallphotodata(val) {
            var vm = this
            this.smallphotodata.forEach(function(item, index) {
                vm.createdCanvasData(item)
            })
        },
        infoWinData() {
            if (this.infoWinData.length == this.smallphotodata.length) {
                this.showSmallphotodata()
            }
        },
        timeIndex() {
            if (this.timeLength == this.timeIndex) {
                this.timeIndex = 0
                this.playheadMap()
                //this.playStatue=false;
                $('.line div').scrollLeft(this.timeIndex)
                //clearInterval(this.playTime);
            } else {
                if (this.timeIndex > 4) {
                    $('.line div').scrollLeft(this.timeIndex * 30)
                }
            }
            this.headmaptime = this.timeData[this.timeIndex]
        },
        headmaptime() {
            this.addHeadMapF()
        },
        handleRoadTime() {
            this.getHandleRoad();
        },
        //图片详情页面
        picIndex() {
            //console.info(this.picIndex)
            if (
                $('.footdiv_active')
                    .find('span')
                    .css('display') != 'none'
            ) {
                this.isImgLoading = true
            }
            this.pxLevel = this.listImg[this.picIndex].indexDescription
            this.initPiaoXuLevel(this.pxLevel)
        },
        showpoto() {
            if (this.showpoto) {
                this.listImg = []
                this.isImgLoading = true
                //this.getPictureData();
                this.filterPhotoData()

                $('body').css('overflow', 'hidden')
            } else {
                this.picIndex = 0
                //$('title').text('悬铃木果毛飘絮预报');
                $('body').css('overflow', 'auto')
                this.isImgLoading = false
                //this.isImgDataLoading=true;
                this.showNetTip = false
            }
        },
        showLayer() {
            lmap.toggleRoad(this.showLayer);
        },
        showImgPoi() {
            if (this.showImgPoi) {
                this.checkPop()
            } else {
                this.hidePop()
            }
        },

        //======拍照上传页面=====
        upLoadstreetName(val) {
            var vm = this
            if (!this.hasSelectStreet) {
                this.isStreetFitContentShow = true
            } else {
                this.hasSelectStreet = false
            }
            this.streetFit = []
            if (val == '') {
                this.isStreetFitContentShow = false
                return
            }
            //道路搜索
            gmap.placeSearch.search(val, function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    var pois = result.poiList.pois
                    //console.info(result.poiList);
                    for (var i in pois) {
                        vm.streetFit.push(pois[i])
                    }
                }
            })
        },
        showpotograph() {
            this.hasSelectStreet = true
            if (this.streetName != '' && this.streetName != '无法定位到街道') {
                this.upLoadstreetName = this.streetName
                //上传照片经纬度数据
                this.streetLat = this.clickPositionObj.lat
                this.streetLon = this.clickPositionObj.lng
            }
            if (this.showpotograph) {
                this.showIndex = false
                this.isImgUpLoading = false
                $('title').text('随手拍拍')
            } else {
                this.piaoxuAcive = 'none'
                this.compressImg = []
                this.isImgUpLoading = false
                this.showIndex = true
                this.isStreetFitContentShow = false
                //$('title').text('悬铃木果毛飘絮预报');
            }
        },
        isShowAreaSelect() {
            var winDow = $(window).width()
            if (winDow > 800) {
                $('.dialog-modal').width(795)
            }
        },
        showBigImgCon() {
            var imgDom = document.getElementById('bigImg')
            imgDom.style.width = '100%'
            imgDom.style.left = this.winWidth / 2 + 'px'
            imgDom.style.top = this.winHight / 2 + 'px'
        }
    },
    methods: {
        ...mapActions(['updateParam']),
        reciprocal() {
            //倒数
            if (this.showJump) {
                if (this.showJumpSs > 0) {
                    if (this.inteReduces) {
                        window.clearInterval(this.inteReduces)
                    }
                    this.inteReduces = window.setTimeout(this.reduces, 1000)
                } else {
                    //前往飘絮城市
                    this.gotoForecastCity()
                }
            }
        },
        clear() {
            // console.log(this)
            this.$router.push('/clear')
        },
        reduces() {
            //减减
            this.showJumpSs = this.showJumpSs - 1
        },
        gotoForecastCity() {
            //前往飘絮城市
            this.showJump = false
            this.showJumpSs = 9
            //地图放大到13级、定位到默认中心
            //console.log(this.citycode)
            var lonlat = this.initStreesInfo[this.citycode].lnglat
            if (lonlat[0] > lonlat[1]) {
                lonlat = [lonlat[0], lonlat[1]]
            } else {
                lonlat = [lonlat[1], lonlat[0]]
            }
            lmap.gotoForecastCity(lonlat)
            this.updateStreeName(lonlat[0], lonlat[1])
            this.getLiveData(lonlat[0], lonlat[1], true)

            if (this.userPosition.success) {
                this.showUserPosition = true
            } else {
                this.showUserPosition = false
            }
            this.showDefaultUserPosition(lonlat[0], lonlat[1]) //gcj02的坐标
        },
        showDefaultUserPosition(lng, lat) {
            this.updateUserPosition(lng, lat)
        },
        addEvent() {
            lmap.map.on('moveend', this.addHeadMapF)
            lmap.map.on('click', this.updateLiveData)
        },
        hideHeadMap() {
            //	lmap.hideHeadMap();
        },
        addHeadMapF() {
            if (this.inteMapEnd) {
                clearTimeout(this.inteMapEnd)
            }
            this.inteMapEnd = setTimeout(this.addHeadMap, 500)
        },
        addHeadMap(type) {
            if (type) {
                this.curTreeType = type
                this.treeOn = type
            }
            this.checkPop()
            //      console.info('----------------------this.inteMapEnd')
            //      console.log(lmap.map.getZoom())
            lmap.showHeadmap(this.headmaptime != null ? this.headmaptime.forecasttime : null, this.citycode, this.curTreeType, this.basePath)
        },
        checkPop() {
            var zoom = lmap.map.getZoom()
            if (!this.showImgPoi) return
            this.mapzoom = zoom
            if (this.smallphotodatalayergroup) {
                var layers = this.smallphotodatalayergroup
                var contentlayers = this.smallphotodatalayerContentgroup
                for (var i = 0; i < layers.length; i++) {
                    if (zoom < 13) {
                        var cm = contentlayers[layers[i]['F']['streetId']]
                        if (cm && cm.get('visible')) {
                            cm.hide()
                        }
                        if (layers[i] && !layers[i].get('visible')) {
                            layers[i].show()
                        }
                    } else {
                        var cm = contentlayers[layers[i]['F']['streetId']]
                        if (cm && !cm.get('visible')) {
                            cm.show()
                        }
                        if (layers[i] && !layers[i].get('visible')) {
                            layers[i].show()
                        }
                    }
                }
            }
            this.idAndTime = ''
            var _this = this
            $('.infoWin').unbind('click')
            $('.infoWin').click(function(e) {
                if (e && e.stopPropagation) {
                    //W3C取消冒泡事件
                    e.stopPropagation()
                } else {
                    //IE取消冒泡事件
                    window.event.cancelBubble = true
                }
                _this.infoWindowCB(this)
            })
        },
        hidePop() {
            if (this.smallphotodatalayergroup) {
                var layers = this.smallphotodatalayergroup
                var contentlayers = this.smallphotodatalayerContentgroup
                for (var i = 0; i < layers.length; i++) {
                    var cm = contentlayers[layers[i]['F']['streetId']]
                    if (cm && cm.get('visible')) {
                        cm.hide()
                    }
                    if (layers[i] && layers[i].get('visible')) {
                        layers[i].hide()
                    }
                }
            }
        },
        cumulationTimeIndex() {
            this.timeIndex = this.timeIndex + 1
        },
        playheadMap() {
            this.playStatue = !this.playStatue
            if (this.playTime) {
                clearInterval(this.playTime)
            }
            if (this.playStatue) {
                this.playTime = setInterval(this.cumulationTimeIndex, 1000)
            }
        },
        updateStreeName(lng, lat) {
            // 点击地图更新街道名称
            // console.info("计算前：" + lat + "," + lng);
            lat = Number(lat) - 0.000019425300003206303
            lng = Number(lng) - 0.000014081100005114422
            // console.info("计算后：" + lat + "," + lng);
            var vm = this
            var url = this.basePath + '/user/getlocation?location=' + lat + ',' + lng
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function(data) {
                    if (data && data.result && data.result.address_component) {
                        var streetName = ''
                        var poidata = data.result.address_component
                        if (poidata.street != '') {
                            streetName = poidata.street
                        } else {
                            streetName = '无法获取街道名'
                        }
                        vm.updateParam([
                            {
                                clickPositionObj: {
                                    lng: lng,
                                    lat: lat,
                                    street: streetName
                                }
                            }
                        ])
                    }
                },
                error: function() {
                    console.info('position translate error!')
                }
            })
        },
        updateUserPosition(lng, lat) {
            //点击地图更新街道名称
            //console.info("计算前：" + lat + "," + lng);
            lat = Number(lat) - 0.000019425300003206303
            lng = Number(lng) - 0.000014081100005114422
            //console.info("计算后：" + lat + "," + lng);
            var vm = this
            var url = this.basePath + '/user/getlocation?location=' + lat + ',' + lng
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function(data) {
                    if (data && data.result && data.result.address_component) {
                        var streetName = ''
                        var poidata = data.result.address_component
                        if (poidata.street != '') {
                            streetName = poidata.street
                        } else {
                            streetName = '无法获取街道名'
                        }
                        vm.updateParam([
                            {
                                userPosition: {
                                    lng: lng,
                                    lat: lat,
                                    street: streetName
                                }
                            }
                        ])
                    }
                },
                error: function() {
                    console.info('position translate error!')
                }
            })
        },
        updateLiveData(e) {
            // 坐标系是4326
            //console.info(e)
            // console.info(e.lnglat['lat']);
            // console.info(e.lnglat['lng']);
            let lnglat = gcoord.transform([e.latlng['lng'], e.latlng['lat']], gcoord.EPSG4326, gcoord.GCJ02)
            //      this.updateStreeName(e.latlng['lng'], e.latlng['lat']);
            //      this.setCookie('FATONG_LONLAT', e.latlng['lng'] + ';' + e.latlng['lat']);
            //      this.getLiveData(e.latlng['lng'], e.latlng['lat'], true);
            this.updateStreeName(lnglat[0], lnglat[1])
            this.setCookie('FATONG_LONLAT', lnglat[0] + ';' + lnglat[1])
            this.getLiveData(lnglat[0], lnglat[1], true) // 传进去的是gcj02
        },
        // 获取道路
        getHandleRoad() {
            var url = this.basePath + '/road/getHandleRoad?time=' + this.handleRoadTime;
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                success: function(data) {
                    this.handleRoad = data || [];
                    // const colorArr = ['black', 'green', 'blue', 'orange', 'purple', 'red'];
                    lmap.clearRoad();
                    this.handleRoad.forEach((area, index) => {
                        const roadArray = area.roadArray || [];
                        if (roadArray.length > 0) {
                            const geojsonArr = area.roadArray.map(road => {
                                const { json: geometry, ...others } = road;
                                const arr = geometry.coordinates[0];
                                // 经纬度修正，以贴合地图上的道路
                                arr.forEach(item => {
                                    item[0] -= 0.0051
                                    item[1] += 0.00205
                                })
                                return {
                                    type: 'Feature',
                                    geometry,
                                    properties: {
                                        ...others
                                    }
                                };
                            });
                            lmap.drawRoad(area.district, geojsonArr,
                                // { style: { color: colorArr[index % colorArr.length]  }}
                            )
                            lmap.toggleRoad(this.showLayer);
                        }
                    })
                },
                error: function() {
                    console.info('getHandleRoad error!');
                    lmap.clearRoad();
                }
            });
        },
        getLiveData(lng, lat, bool) {
            if (this.forecastTime === '') {
                return '';
            }
            var preLonLat = []
            if (lng && lat) {
                //点击地图
                let lnglat = coordtransform.gcj02towgs84(lng, lat)
                this.addClickPoi(lnglat[0], lnglat[1], bool)
                preLonLat = [lng, lat]
            } else {
                preLonLat = [Number(this.clickPositionObj.lng), Number(this.clickPositionObj.lat)]
            }
            let latlng
            if (Number(preLonLat[0]) > Number(preLonLat[1])) {
                latlng = [preLonLat[1], preLonLat[0]]
            } else {
                latlng = [preLonLat[0], preLonLat[1]]
            }
            let lnglat = coordtransform.gcj02towgs84(lng, lat)
            let lnglat2
            if (Number(lnglat[0]) > Number(lnglat[1])) {
                lnglat2 = [lnglat[0], lnglat[1]]
            } else {
                lnglat2 = [lnglat[1], lnglat[0]]
            }
            lmap.map.setView([lnglat2[1], lnglat2[0]]) //wgs84
            //lmap.map.setView(latlng); // gcj02
            lmap.map.invalidateSize(true)
            var vm = this
            console.log('实况数据：' + latlng[1] + '-----' + latlng[0])
            $.ajax({
                type: 'POST',
                data: {
                    longitude: latlng[1],
                    latitude: latlng[0],
                    // longitude: 118.79647,
                    // latitude: 32.05838,
                    citycode: this.citycode,
                    liveTime: this.liveTime,
                    forecastTime: this.forecastTime
                },
                url: vm.basePath + '/user/liveforcast',
                dataType: 'json',
                success: function(data) {
                    if (data[0].status == 1 || vm.streetName == '无法定位到街道') {
                        vm.liveStatus = 1
                        vm.failLiveData[1].live.publishTime = data[1].live.publishTime
                        vm.failLiveData[2].forcast.xdata = data[2].forcast.xdata
                        data = vm.failLiveData
                    } else {
                        vm.liveStatus = 0
                    }
                    //vm.liveDescript=data[1].live.description;
                    vm.streetId = data[1].live.streetId
                    vm.level = data[1].live.level
                    vm.indexvalue = data[1].live.indexLiveValue
                    vm.publishTime = data[1].live.publishTime
                    if (vm.citycode != '320100') {
                        vm.treeType = data[1].live.treetype
                    }
                    if (vm.getCookie('FATONG_CORRECT_' + vm.streetId) == '1') {
                        vm.unCorrectSelected = true
                    } else if (vm.getCookie('FATONG_CORRECT_' + vm.streetId) == '0') {
                        vm.correctSelected = true
                    } else {
                        vm.correctSelected = false
                        vm.unCorrectSelected = false
                    }
                    //设置播放轴和互动信息样式
                    vm.interactiveCss(data[1].live)
                    vm.linechartCss(data[2].forcast.data)
                    //图表方法
                    vm.levelcolor = drawGaugeCanvas.drawCanvas('myCanvas', data[1].live.indexLiveValue, data[1].live.publishTime, $)
                    //console.info(data[2].forcast.data)
                    //data[2].forcast.data = [0,50,5,1,1,6,1,2,1,1,1,1,1,1,1,1]
                    drawHighChartLine.drawLine('lineChartContent', data[2].forcast.data, data[2].forcast.xdata, Highcharts)
                },
                error: function() {
                    console.info('实况信息请求失败！')
                }
            })
        },
        correctAction() {
            var vm = this
            vm.idAndTime = ''
            if (vm.liveStatus == 1) {
                vm.discriptionTipDialog.find('p').text(vm.failLiveData[1].live.description)
                vm.discriptionTipDialog.parent().fadeIn(500)
                return
            }
            $('.infoWinSelected').removeClass('infoWinSelected')
            if (vm.unCorrectSelected || vm.correctSelected) {
                var clickTime = vm.getCookie('FATONG_CORRECT_time' + vm.streetId)
                clickTime == '' ? (clickTime = 0) : parseInt(clickTime)
                if (clickTime == 10) {
                    vm.discriptionTipDialog.find('p').text('点击次数过多，请稍后再点！')
                    vm.discriptionTipDialog.parent().fadeIn(500)
                    return
                }
                vm.unCorrectSelected = false
                vm.correctSelected = true
                vm.setCookie('FATONG_CORRECT_time' + vm.streetId, ++clickTime)
            }
            vm.interactive(1, 0, vm.streetId, 0)
            vm.setCookie('FATONG_CORRECT_' + vm.streetId, 0, 3600)
            vm.correctSelected = true
        },
        unCorrectAction() {
            var vm = this
            vm.idAndTime = ''
            if (vm.liveStatus == 1) {
                vm.discriptionTipDialog.find('p').text(vm.failLiveData[1].live.description)
                vm.discriptionTipDialog.parent().fadeIn(500)
                return
            }
            $('.infoWinSelected').removeClass('infoWinSelected')
            if (vm.unCorrectSelected || vm.correctSelected) {
                var clickTime = vm.getCookie('FATONG_CORRECT_time' + vm.streetId)
                clickTime == '' ? (clickTime = 0) : parseInt(clickTime)
                if (clickTime == 10) {
                    vm.discriptionTipDialog.find('p').text('点击次数过多，请稍后再点！')
                    vm.discriptionTipDialog.parent().fadeIn(500)
                    return
                }
                vm.correctSelected = false
                vm.unCorrectSelected = true
                vm.setCookie('FATONG_CORRECT_time' + vm.streetId, ++clickTime)
            }
            vm.showUNCorrectMask = true
        },
        unCorrectListAction(type) {
            //console.info(type)
            event.stopPropagation()
            this.correctSelected = false
            this.unCorrectSelected = true
            this.showUNCorrectMask = false
            this.interactive(0, 1, this.streetId, type)
            this.setCookie('FATONG_CORRECT_' + this.streetId, 1, 3600)
        },
        //准/不准交互事件
        interactive(accurate, notaccurate, streetId, indexDes) {
            var vm = this
            $.ajax({
                type: 'POST',
                url: vm.basePath + '/user/interactiveSave',
                data: {
                    accurate: accurate,
                    notaccurate: notaccurate,
                    streetId: streetId,
                    indexDescription: indexDes,
                    city: vm.citycode
                },
                dataType: 'json',
                success: function(data) {
                    vm.maxUncorrect = data[0].maxUncorrect
                    vm.maxLevel = data[0].maxLevel == '无' ? '对出行无影响' : data[0].maxLevel == '轻度' ? '对出行基本无影响' : data[0].maxLevel
                    vm.correct = data[0].accurate
                    vm.uncorrect = data[0].notaccurate
                }
            })
        },
        //互动信息初始化
        interactiveCss(interactiveData) {
            var vm = this
            if (interactiveData.description.length > 25) {
                vm.discriptionDom = '<span class="icon"></span>' + interactiveData.description.substring(0, 23) + '...<span class="stretchBtn open"></span>'
            } else {
                vm.discriptionDom = '<span class="icon"></span>' + interactiveData.description
            }
            vm.liveDescript = interactiveData.description
            vm.maxUncorrect = interactiveData.maxUncorrect
            vm.maxLevel = interactiveData.maxLevel == '无' ? '对出行无影响' : interactiveData.maxLevel == '轻度' ? '对出行基本无影响' : interactiveData.maxLevel
            vm.correct = interactiveData.accurate
            vm.uncorrect = interactiveData.notaccurate
            if (vm.getCookie('FATONG_CORRECT_' + vm.streetId) == '1') {
                //不准
                vm.unCorrectSelected = true
            } else if (vm.getCookie('FATONG_CORRECT_' + vm.streetId) == '0') {
                vm.correctSelected = true
            }
            //设置用户指引左上角表情图
            var levelClass = ''
            switch (interactiveData.level) {
                case '无':
                    levelClass = 'none'
                    break
                case '轻度':
                    levelClass = 'mild'
                    break
                case '中度':
                    levelClass = 'moderate'
                    break
                case '重度':
                    levelClass = 'severe'
                    break
            }
            $('.discription')
                .removeClass()
                .addClass('discription ' + levelClass)
        },
        eventHandler() {
            var vm = this
            $('.discription').on('click', '.stretchBtn', function() {
                vm.discriptionTipDialog.find('p').text(vm.liveDescript)
                vm.discriptionTipDialog.parent().fadeIn(500)
            })

            $('.discriptionTip-dialog-closer,.dialog-modal').click(function() {
                vm.discriptionTipDialog.parent().fadeOut(500)
            })
        },
        //地图信息窗口点击回调
        infoWindowCB(obj) {
            var vm = this
            this.idAndTime = $(obj).attr('id')
            $('.infoWinSelected').removeClass('infoWinSelected')
            $(obj).addClass('infoWinSelected')
            vm.streetId = vm.idAndTime.split(';')[0]
            vm.showpoto = !vm.showpoto
            //vm.setCookie('FATONG_IMG_IDANDTIME',this.idAndTime);
        },
        setCookie(c_name, value, expiretime) {
            var exdate = new Date()
            exdate.setTime(exdate.getTime() + expiretime * 1000)
            document.cookie = c_name + '=' + escape(value) + (expiretime == null ? '' : ';expires=' + exdate.toGMTString())
        },
        getCookie(c_name) {
            if (document.cookie.length > 0) {
                var c_start = document.cookie.indexOf(c_name + '=')
                if (c_start != -1) {
                    c_start = c_start + c_name.length + 1
                    var c_end = document.cookie.indexOf(';', c_start)
                    if (c_end == -1) c_end = document.cookie.length
                    //console.info(document.cookie)
                    return unescape(document.cookie.substring(c_start, c_end))
                } else {
                    return ''
                }
            }
            return ''
        },
        linechartCss(Data) {
            var bodyWidth = $('body').width()
            // $('.lineChartWarp').width(bodyWidth);
            $('.lineChartContent').width(Data.length * 50)
            $('.chartMask').width(Data.length * 50)
        },

        culHeght() {
            /*计算高度*/
            var vm = this
            this.discriptionTipDialog = $('.discriptionTip-dialog')
            this.screenHeight = window.screen.height
            this.winHight = $(window).height()
            this.winWidth = $(window).width()
            $('.wechat').css({
                'min-height': this.winHight - 57
            })
            $('.tb').height(this.winHight * 0.65)
            $('.lineChart').height(this.winHight * 0.35)
            $('.circleChart').height(this.winHight * 0.65 * 0.5)
            var lineH = $('.lineChartTitle').height()
            $('.lineChartContent').height($('.lineChart').height() - lineH)
            var c = document.getElementById('myCanvas')
            //console.info(navigator.userAgent)
            if (navigator.userAgent.indexOf('Windows') > 0) {
                $('.circleChartTitle').css('top', '27%')
                $('.chartValue').css('top', '33%')
                $('.level').css('top', '57%')
                $('.publishTime').css('top', '70%')
            }
            if (this.winWidth > 800) {
                this.winWidth = 778
            }
            if (this.winWidth <= 320) {
                c.width = 170
                c.height = 170
                $('.canvasText')
                    .height(170)
                    .width(170)
            }
            $(window).resize(function() {
                if (this.winWidth <= 320) {
                    c.width = 170
                    c.height = 170
                }
            })
            if ($(window).height() > 510) {
                $('.tb2').height($('.tb').height())
            } else {
                $('.tb2').height($('.tb').height() - 20)
            }
        },
        updateOrientation() {
            var vm = this
            var bodyWidth = $('body').width()
            var lineWidth = bodyWidth - 33
            $('.lineChartWarp').width(bodyWidth)
            $('.line').width(lineWidth)

            if (window.innerWidth > window.innerHeight) {
                //console.info('横屏')
                $('.copyRight').css('bottom', '-9px')
                $('.image-list').css('height', '17%')
            } else {
                //console.info('竖屏')
                $('.copyRight').css('bottom', '-3px')
                $('.image-list').css('height', '12%')
            }
        },
        isUsercanvas() {
            try {
                var e = navigator.userAgent
                if (!e) {
                    return false
                }
                if (e.match(/iPhone|iPod/i)) {
                    return true
                } else {
                    return false
                }
            } catch (ex) {
                return false
            }
        },
        addPosition(lng, lat) {
            /*let lnglat = gcoord.transform( // 传进来的是gcj02，转成wgs84，用于天地图
                [lng, lat],
                gcoord.GCJ02,
                gcoord.EPSG4326
            )*/
            let lnglat = coordtransform.gcj02towgs84(lng, lat)
            //console.log(lng,lat)
            //console.log('------position-------')
            if (this.lonlatLayer) {
                this.lonlatLayer.setLatLng([lnglat[1], lnglat[0]])
            } else {
                this.lonlatLayer = L.marker([lnglat[1], lnglat[0]], {
                    icon: L.icon({
                        iconUrl: base64Img['positionIcon'],
                        iconSize: [60, 60],
                        iconAnchor: [30, 60]
                    })
                }).addTo(lmap.map)
            }
            return
            if (navigator.userAgent.indexOf('Android') > -1) {
                //安卓
                console.log('安卓转换前：' + lng + '---' + lat)
                let lnglat = gcoord.transform(
                    // 传进来的是gcj02，转成wgs84，用于天地图
                    [lng, lat],
                    gcoord.EPSG4326,
                    gcoord.GCJ02
                )
                console.log('安卓转换后：' + lnglat[0] + '---' + lnglat[1])
                //console.log(lng,lat)
                //console.log('------position-------')
                if (this.lonlatLayer) {
                    this.lonlatLayer.setLatLng([lat, lng])
                } else {
                    this.lonlatLayer = L.marker([lat, lng], {
                        icon: L.icon({
                            iconUrl: base64Img['positionIcon'],
                            iconSize: [60, 60],
                            iconAnchor: [30, 60]
                        })
                    }).addTo(lmap.map)
                }
            } else if (navigator.userAgent.indexOf('iPhone') > -1) {
                // ios
                console.log('ios转换前：' + lng + '---' + lat)
                let lnglat = gcoord.transform(
                    // 传进来的是gcj02，转成wgs84，用于天地图
                    [lng, lat],
                    gcoord.GCJ02,
                    gcoord.EPSG4326
                )
                console.log('ios转换后：' + lnglat[0] + '---' + lnglat[1])
                //console.log(lng,lat)
                //console.log('------position-------')
                if (this.lonlatLayer) {
                    this.lonlatLayer.setLatLng([lnglat[1], lnglat[0]])
                } else {
                    this.lonlatLayer = L.marker([lnglat[1], lnglat[0]], {
                        icon: L.icon({
                            iconUrl: base64Img['positionIcon'],
                            iconSize: [60, 60],
                            iconAnchor: [30, 60]
                        })
                    }).addTo(lmap.map)
                }
            }
        },
        addClickPoi(lng, lat, bool) {
            //添加点击的图标
            //console.info(lng, lat, bool)
            //console.info('-----------------clickpoi---------------------')
            if (!bool) {
                return
            }
            if (this.clickPoiLayer) {
                this.clickPoiLayer.setLatLng([lat, lng])
            } else {
                this.clickPoiLayer = L.marker([lat, lng], {
                    icon: L.icon({
                        iconUrl: base64Img['clickpoi'],
                        iconSize: [20, 20],
                        iconAnchor: [10, 20]
                    })
                }).addTo(lmap.map)
            }
        },
        removeClickPoi() {
            if (this.clickPoiLayer) {
                this.clickPoiLayer.remove()
                this.clickPoiLayer = null
            }
        },
        pan() {
            //this.getGaodeLocation();
            this.getNewLocation()
            /*lmap.map.setView([32.009989626962835,118.869969096869288],13)
            let lnglat = gcoord.transform(
                [118.875, 32.007801],
                gcoord.GCJ02,
                gcoord.EPSG4326
            )
            lmap.map.setView([lnglat[1],lnglat[0]],13)*/
        },
        showPosition() {
            //定位
            var lng = this.clickPositionObj['lng']
            var lat = this.clickPositionObj['lat']
            var city = this.clickPositionObj['city']
            var vm = this
            var url = this.basePath + '/user/getlocation?location=' + lat + ',' + lng
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function(data) {
                    if (data && data.result && data.result.address_component) {
                        var poidata = data.result.address_component
                        if (poidata.street != '') {
                            vm.streetName = poidata.street
                        }
                    }
                },
                error: function() {
                    console.info('position translate error!')
                }
            })
        },
        showSmallphotodata() {
            var vm = this
            this.smallphotodatalayergroup = []
            this.smallphotodatalayerContentgroup = {}
            for (var i = 0; i < this.infoWinData.length; i++) {
                var dataobj = this.infoWinData[i]
                //var position = [(Number(dataobj['lng'])-0.006371316499993895).toFixed(6),(Number(dataobj['lat'])-0.0063022097000029476).toFixed(6)];
                var position = [Number(dataobj['lng']), Number(dataobj['lat'])]
                var marker = new AMap.Marker({
                    //添加自定义点标记
                    map: gmap.map,
                    clickable: true,
                    icon: base64Img['pano'],
                    position: position, //基点位置
                    zIndex: 9999,
                    draggable: false, //是否可拖动
                    visible: vm.showImgPoi,
                    streetId: dataobj.streetId
                })
                var _this = this
                AMap.event.addListener(marker, 'click', function(e) {
                    var cm = _this.smallphotodatalayerContentgroup[e.target['F']['streetId']]
                    if (cm) {
                        if (!cm.get('visible')) {
                            cm.show()
                        } else {
                            cm.hide()
                        }
                    }
                })
                this.smallphotodatalayergroup.push(marker)
                var extdata = {
                    streetId: dataobj.streetId,
                    dataTime: dataobj.dataTime,
                    photoUrls: dataobj.photoUrls
                }
                var infoWinMarker = new AMap.Marker({
                    //添加自定义点标记
                    map: gmap.map,
                    clickable: true,
                    position: position, //基点位置
                    zIndex: 99999,
                    offset: new AMap.Pixel(-45, -99), //相对于基点的偏移位置
                    draggable: false, //是否可拖动
                    icon: new AMap.Icon({
                        size: new AMap.Size(88, 70), //图标大小
                        image: dataobj.smallUrl[0].url
                    }),
                    extData: extdata,
                    bubble: false,
                    visible: vm.showImgPoi
                })

                infoWinMarker.on('click', function() {
                    var extdata = this.getExtData()
                    vm.streetId = extdata.streetId
                    vm.showpoto = !vm.showpoto
                    vm.photodata = extdata.photoUrls
                })
                this.smallphotodatalayerContentgroup[extdata.streetId] = infoWinMarker
            }
            this.checkPop()
        },
        createdCanvasData(dataobj) {
            var vm = this
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            canvas.height = 70
            canvas.width = 88
            var infoWinSrc = ''
            var purl = dataobj['smallUrl']
            var color, win
            var url = vm.basePath + '/user/uploadphoto'
            purl = purl[0].url.replace('./uploadphoto', url)

            switch (dataobj['indexDescription'].substring(0, 1)) {
                case '无':
                    win = 'green'
                    color = '#38c99e'
                    break
                case '轻':
                    win = 'yellow'
                    color = '#f2e838'
                    break
                case '中':
                    win = 'orange'
                    color = '#ffa500'
                    break
                case '重':
                    win = 'red'
                    color = '#ff0000'
                    break
            }
            var img = new Image()
            var img2 = new Image(40, 70)
            img.src = base64Img[win]
            img.onload = function() {
                ctx.drawImage(img, 0, 0, 88, 70)
                ctx.fillStyle = color
                ctx.fillRect(53, 43, 28, 14)
                ctx.fillStyle = '#fff'
                ctx.font = '15px bold'
                ctx.fillText(dataobj.smallUrl[0].indexDescription.substring(0, 1), 60, 55)
                ctx.fillStyle = '#000'
                ctx.fillText(dataobj.streetName.substring(0, 3), 7, 55)
            }
            img2.src = purl
            img2.onload = function() {
                ctx.drawImage(img2, 7, 6, 74, 35)
                infoWinSrc = canvas.toDataURL('image/png', 1)
                var data = {
                    dataTime: dataobj.dataTime,
                    lat: dataobj.lat,
                    lng: dataobj.lng,
                    smallUrl: [
                        {
                            indexDescription: dataobj.smallUrl.indexDescription,
                            url: infoWinSrc
                        }
                    ],
                    photoUrls: dataobj.wxSmallPhoto,
                    streetId: dataobj.streetId,
                    streetName: dataobj.streetName,
                    cityCode: vm.citycode
                }
                vm.infoWinData.push(data)
            }
        },
        zoom() {
            $('.infoWinSelected').removeClass('infoWinSelected')
            if ($('#zoom').hasClass('zunSelect')) {
                $('#zoom').text('退出全屏')
                $('.levelIconWrap').hide()
                $('#zoom')
                    .removeClass('zunSelect')
                    .addClass('zSelect')
                $('#mapoutside')
                    .removeClass('map1')
                    .addClass('map2')
                //$('title').text('悬铃木果毛飘絮预报');
                $('.levelIcon').css('z-index', '0')
                $('.lineChart ul').addClass('lineChartUl')
                $('.timeLine').css({
                    position: 'fixed',
                    bottom: '0px',
                    height: '49px'
                })
                $('.mapHander').css('position', 'fixed')
                $('.mapHander').css('bottom', '80px')
                $('.lineChart ul').css('right', ($('html').width() - this.winWidth) / 2 + 10 + 'px')
                $('.mapHander').css('right', ($('html').width() - this.winWidth) / 2 + 10 + 'px')
                $('body').css('overflow', 'hidden')
                // $('.treeTypeDiv').css({'position':'fixed','top':'10px','left':'10px'})
                $('.treeTypeDiv').css({
                    position: 'fixed',
                    left: ($('html').width() - this.winWidth) / 2 + 10 + 'px',
                    top: '10px'
                })
            } else {
                $('#zoom').text('全屏')
                $('.levelIconWrap').show()
                $('#zoom')
                    .addClass('zunSelect')
                    .removeClass('zSelect')
                $('#mapoutside')
                    .removeClass('map2')
                    .addClass('map1')
                $('body').scrollTop(1000)
                $('.levelIcon').css('z-index', '10')
                $('.lineChart ul').removeClass('lineChartUl')
                //$('title').text('悬铃木果毛飘絮预报');
                $('.timeLine').css({
                    position: 'relative',
                    bottom: '0px'
                })
                $('.mapHander').css('position', 'absolute')
                $('.lineChart ul').css('right', '5px')
                $('.mapHander').css('right', '8px')
                $('body').css('overflow', 'auto')
                $('.treeTypeDiv').css({
                    position: 'absolute',
                    top: '10px',
                    left: '10px'
                })
            }
            lmap.map.invalidateSize(true)
        },
        //=======图片详情页面============
        initPiaoXuLevel(indexDescription) {
            switch (indexDescription) {
                case '轻':
                    this.pxClass = 'mild'
                    break
                case '中':
                    this.pxClass = 'moderate'
                    break
                case '重':
                    this.pxClass = 'severe'
                    break
                default:
                    this.pxClass = 'none'
            }
        },
        switchLevelIndex(level) {
            var levelindex
            switch (level) {
                case 'mild':
                    levelindex = 1
                    break
                case 'moderate':
                    levelindex = 2
                    break
                case 'severe':
                    levelindex = 3
                    break
                default:
                    levelindex = 0
            }
            return levelindex
        },
        imageLoaded() {
            this.isImgLoading = false
            $(event.target).hide()
            $(event.target).fadeIn()
        },
        imglistLoaded() {
            $(event.target)
                .next()
                .hide()
        },
        imageError() {
            this.isImgLoading = false
            $(event.target).attr('src', base64Img['errorImg'])
        },
        showBigImg(src) {
            this.bigImgSrc = src
            this.showBigImgCon = true
        },
        imgHammer() {
            var vm = this
            this.hammer = new Hammer(document.getElementById('swiper-wrapper'))
            this.hammer.on('swipe', function(ev) {
                if (ev.deltaX > 0) {
                    if (vm.picIndex == 0) return --vm.picIndex
                } else {
                    if (vm.picIndex + 1 == vm.listImg.length) return ++vm.picIndex
                }
                $('.image-list div').scrollLeft(vm.picIndex * 40)
            })
            var imgDom = document.getElementById('bigImg')
            var bigImg = new Hammer(imgDom)
            bigImg.get('pinch').set({
                enable: true
            })
            bigImg.on('pinchout', e => {
                if (vm.scaleLevel > 0.6) {
                    vm.scaleLevel = 0.6
                    return
                } else {
                    vm.scaleLevel += 0.1
                }
                imgDom.style.width = 100 + 100 * vm.scaleLevel + '%'
            })
            bigImg.on('pinchin', e => {
                if (vm.scaleLevel <= 0) {
                    vm.scaleLevel = 0
                    imgDom.style.width = '100%'
                    imgDom.style.left = imgDom.width / 2 + 'px'
                    imgDom.style.top = vm.winHight / 2 + 'px'
                    return
                } else {
                    vm.scaleLevel -= 0.1
                    imgDom.style.width = 100 + 100 * vm.scaleLevel + '%'
                }
            })
            bigImg.on('pan', e => {
                if (vm.scaleLevel <= 0) return
                if (vm.winWidth - imgDom.width / 2 - 1 < imgDom.offsetLeft && imgDom.offsetLeft < imgDom.width / 2 + 1) {
                    imgDom.style.left = imgDom.offsetLeft + e.deltaX / 10 + 'px'
                    imgDom.style.top = imgDom.offsetTop + e.deltaY / 15 + 'px'
                } else if (imgDom.offsetLeft < vm.winWidth - imgDom.width / 2) {
                    imgDom.style.left = vm.winWidth - imgDom.width / 2 + 'px'
                } else {
                    imgDom.style.left = imgDom.width / 2 + 'px'
                }
            })
        },
        getPictureData() {
            var vm = this
            $.ajax({
                type: 'get',
                url: this.basePath + '/webfile/jsonDataFile_new/photodata.json?r=' + Math.random(),
                dataType: 'json',
                success: function(res) {
                    vm.photodata = res[0]
                    vm.filterPhotoData()
                    //vm.isImgDataLoading=false;
                },
                error: function(xhr) {
                    console.info('请求失败！')
                    //vm.isImgDataLoading=false;
                    vm.isImgLoading = false
                    vm.showNetTip = true
                }
            })
        },
        filterPhotoData() {
            if (this.streetId == 0) return
            this.pxLevel = this.photodata['indexDescription']
            this.initPiaoXuLevel(this.pxLevel)
            this.listImg = this.photodata['picDataList']
            //this.isImgLoading = true;
            //console.info(this.listImg)
            this.imgLength = this.listImg.length
            $('title').text(this.photodata['streetName'])
        },
        getWeiXinLocationFSign() {
            var _this = this
            $.ajax({
                url: _this.basePath + '/sign/getSign',
                data: {
                    cityCode: _this.citycode
                },
                type: 'get',
                dataType: 'json',
                success: function(data) {
                    _this.getWeiXinLocation(data)
                }
            })
        },
        getWeiXinLocation(data) {
            var _this = this
            console.log(
                {
                    debug: false,
                    appId: data[0]['appId'],
                    timestamp: data[0]['timestamp'],
                    nonceStr: data[0]['noncestr'],
                    signature: data[0]['signature'],
                    jsApiList: ['getLocation']
                },
                'ffff'
            )
            try {
                wx.config({
                    debug: false,
                    appId: data[0]['appId'],
                    timestamp: data[0]['timestamp'],
                    nonceStr: data[0]['noncestr'],
                    signature: data[0]['signature'],
                    jsApiList: ['getLocation']
                })
            } catch (e) {
                console.log(e, '111')
                _this.getGaodeLocation_bak();
            }
            wx.ready(function() {
                // 1 判断当前版本是否支持指定 JS 接口，支持批量判断
                wx.checkJsApi({
                    jsApiList: ['getLocation'],
                    success: function(res) {
                        console.log(res, 'res')
                        // 以键值对的形式返回，可用的api值true，不可用为false
                        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                        if (res.errMsg.indexOf(':ok') == -1) {
                            _this.defaultLocal()
                        }
                    }
                })
                wx.getLocation({
                    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function(res) {
                        console.log(res, 'resrrr')
                        _this.isLocation = false
                        _this.streetLat = res.latitude
                        _this.streetLon = res.longitude

                        var timeUrl = _this.basePath + '/user/getlocation?location=' + res.latitude + ',' + res.longitude
                        _this.$http.get(timeUrl).then(response => {
                            console.log(response, reponse)
                            response = response.body.result
                            //更新用户位置
                            var ad_info = response.ad_info
                            var address_component = response.address_component
                            var _userPosition = {
                                //lng: ad_info.location.lng,
                                //lat: ad_info.location.lat,
                                lng: res.longitude,
                                lat: res.latitude,
                                city: ad_info.city,
                                adcode: ad_info.adcode,
                                street: address_component.street,
                                success: true
                            }
                            _this.updateStreeName(res.longitude, res.latitude)
                            _this.getLiveData(res.longitude, res.latitude, true)
                            _this.updateParam([
                                {
                                    userPosition: _userPosition
                                }
                            ])
                            _this.updateParam([
                                {
                                    clickPositionObj: _userPosition
                                }
                            ])
                            _this.checkCurCity()
                        })
                        var lat1 = Number(res.latitude)
                        var lng1 = Number(res.longitude)
                        _this.addPosition(lng1, lat1)
                    },
                    fail: function(error) {
                        console.log('before')
                        console.log(error)
                        console.log('after')
                        _this.getGaodeLocation_bak();
                    },
                    cancel: function(res) {
                        _this.getGaodeLocation_bak();
                        //_this.addPosition(Number(_this.positionObj.lng),Number(_this.positionObj.lat));
                    }
                })
            })
        },

        getGaodeLocation_bak() {
            var vm = this
            const url = 'https://apis.map.qq.com/ws/location/v1/ip'
            this.$http
                .jsonp(url, {
                    params: {
                        key: 'RTABZ-TFDRW-VHWRQ-RECSG-NQ5NJ-JHBSU',
                        output: 'jsonp'
                    },
                    jsonp: 'callback'
                })
                .then(response => {
                    const { lng: lon, lat } = response.body.result.location
                    // 这些照搬就行，部分根据自己实际需要来调整
                    // vm.gaodelocation = new AMap.Geolocation()
                    // gmap.map.addControl(this.geolocation);
                    // vm.gaodelocation.getCurrentPosition()

                    // AMap.event.addListener(vm.gaodelocation, 'error', function() {
                    //     vm.gotoForecastCity()
                    // })

                    // 如为IP精确定位结果则没有精度信息
                    // var _userPosition = {
                    //     lng: data.position.getLng(),
                    //     lat: data.position.getLat(),
                    //     city: data.addressComponent.city,
                    //     adcode: data.addressComponent.adcode.substr(0, 4) + '00',
                    //     street: data.addressComponent.street,
                    //     success: true
                    // }

                    var _userPosition = {
                        lng: lon,
                        lat: lat,
                        city: response.body.result.ad_info.city,
                        adcode: (response.body.result.ad_info.adcode + '').substr(0, 4) + '00',
                        // street: data.addressComponent.street,
                        success: true
                    }

                    vm.updateStreeName(_userPosition['lng'], _userPosition['lat'])
                    vm.updateParam([
                        {
                            userPosition: {
                                lng: _userPosition['lng'],
                                lat: _userPosition['lat'],
                                street: ''
                            }
                        }
                    ])
                    vm.updateUserPosition(_userPosition['lng'], _userPosition['lat'])
                    vm.getLiveData(_userPosition['lng'], _userPosition['lat'], true)
                    vm.checkCurCity()
                    return _userPosition

                    var lnglatXY = [lon, lat]
                    AMap.service('AMap.Geocoder', function() {
                        // 回调函数
                        // 实例化Geocoder
                        geocoder = new AMap.Geocoder({
                            city: '010' //城市，默认：“全国”
                        })
                        // TODO: 使用 geocoder 对象完成相关功能
                        geocoder.getAddress(lnglatXY, function(status, result) {
                            /*
                            console.log('---------------')
                            console.log(result)
                        */
                            if (status === 'complete' && result.info === 'OK') {
                                // console.info(result.regeocode.formattedAddress)
                            } else {
                                // 获取地址失败
                                vm.gotoForecastCity()
                                // alert('定位失败，请手动选择')
                            }
                        })
                    })

                    /*
                    geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
                        timeout: 10000, // 超过10秒后停止定位，默认：无穷大
                        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                        buttonPosition:'RB'
                    });
                */

                    // 返回定位出错信息
                    AMap.event.addListener(vm.gaodelocation, 'complete', function(data) {
                        // console.log('---------------')
                        // console.log(data);
                        // console.log('定位成功');
                        // console.log('经度：' + data.position.getLng());
                        // console.log('纬度：' + data.position.getLat());
                        // console.log('是否经过偏移：' + (data.isConverted ? '是' : '否'));
                        // console.log('你的当前位置：' + (data.formattedAddress));
                        // if (data.accuracy) {
                        //     console.log('精度：' + data.accuracy + ' 米');
                        // }
                    }) //返回定位信息
                })

            // gmap.map.plugin('AMap.Geolocation', function() {

            // })
        },

        getGaodeLocation() {
            const geolocation = new qq.maps.Geolocation('TKUBZ-D24AF-GJ4JY-JDVM2-IBYKK-KEBCU', '蚊子出没预报')
            this.getGaodeLocation_bak()
            geolocation.getLocation((response) => {
                const { lng: lon, lat } = response
                const _userPosition = {
                    lng: lon,
                    lat: lat,
                    city: response.city,
                    adcode: (response.adcode + '').substr(0, 4) + '00',
                    success: true
                }
                this.updateParam([
                    {
                        userPosition: {
                            lng: _userPosition['lng'],
                            lat: _userPosition['lat'],
                            street: ''
                        }
                    }
                ])
                this.updateUserPosition(_userPosition['lng'], _userPosition['lat'])
                this.getLiveData(_userPosition['lng'], _userPosition['lat'], true)
                this.checkCurCity()

            }, (e) => {
                this.getGaodeLocation_bak();
            }, { timeout: 90000, enableHighAccuracy: false })

            // 精确定位
            let _self = this;
            var map = new AMap.Map('container', {
                resizeEnable: true
            });
            AMap.plugin('AMap.Geolocation', function() {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, // 是否使用高精度定位，默认:true
                    timeout: 10000,          // 超过10秒后停止定位，默认：5s
                    buttonPosition:'RB',    // 定位按钮的停靠位置
                    buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true,   // 定位成功后是否自动调整地图视野到定位点

                });
                map.addControl(geolocation);
                geolocation.getCurrentPosition(function(status,result) {
                    if (status=='complete') {
                        const lon = result.position.lng;
                        const lat = result.position.lat;
                        var lnglatXY = [lon, lat];
                        const _userPosition = {
                            lng: lon,
                            lat: lat,
                            success: true
                        }

                        _self.updateParam([
                            {
                                userPosition: {
                                    lng: lon,
                                    lat: lat,
                                    street: ''
                                }
                            }
                        ])
                        _self.updateStreeName(lon, lat);
                        _self.updateUserPosition(_userPosition['lng'], _userPosition['lat'])
                        _self.getLiveData(_userPosition['lng'], _userPosition['lat'], true)
                        _self.checkCurCity()

                        AMap.service('AMap.Geocoder', function() {// 回调函数
                            let geocoder = new AMap.Geocoder({});
                            geocoder.getAddress(lnglatXY, function(status, result) {
                                if (status === 'complete' && result.info === 'OK') {
                                    var address = result.regeocode.addressComponent;
                                    let streetName = '';
                                    if (address.street != '') {
                                        streetName = address.street
                                    } else {
                                        streetName = '无法获取街道名'
                                    }
                                    _self.updateParam([
                                        {
                                            clickPositionObj: {
                                                lng: lon,
                                                lat: lat,
                                                street: streetName
                                            }
                                        }
                                    ])
                                }
                            });
                        });
                    } else {
                        _self.getGaodeLocation_bak();
                    }
                });
            })
        },

        getNewLocation() {
            var isweixn = this.is_weixin();
            // this.getGaodeLocation();
            if (isweixn) {
                this.getWeiXinLocationFSign()
            }
            else {
                this.getGaodeLocation()
            }
        },
        checkCurCity() {
            var userPosition = this.userPosition
            if (userPosition.success) {
                //定位成功
                //判断当前城市是否为飘絮城市
                if (this.citycode == userPosition.adcode.substr(0, 4) + '00') {
                    //是
                    console.log('当前属于南京市')
                    this.showJump = false
                    console.log('lng:' + userPosition['lng'] + '---' + 'lat:' + userPosition['lat'])
                    //lmap.gotoForecastCity([userPosition['lng'], userPosition['lat']]);
                    //this.addPosition(userPosition['lng'], userPosition['lat'])
                    lmap.gotoForecastCity([userPosition['lng'], userPosition['lat']])
                    this.addPosition(userPosition['lng'], userPosition['lat'])
                    //this.gotoForecastCity()
                    lmap.showHeadmap(this.headmaptime != null ? this.headmaptime.forecasttime : null, this.citycode, this.curTreeType, this.basePath)
                } else {
                    //不是
                    this.showJump = true
                }
            } else {
                this.showJump = false
                lmap.gotoForecastCity([userPosition['lng'], userPosition['lat']])
            }
        },
        defaultLocal() {
            var lonlat = this.initStreesInfo[this.citycode].lnglat
            var _positionObj = {
                lng: lonlat[0],
                lat: lonlat[1],
                city: ''
            }
            this.updateParam([
                {
                    clickPositionObj: _positionObj
                }
            ])
        },
        //======拍照上传页面=====
        uploadChange(fileid, imgid) {
            //上传图片
            //获取文件路径
            //console.info(event.target.files[0])
            var imgPre = document.getElementById(imgid)
            var imgData = this.getFileUrl(fileid, imgPre)
            this.compress(imgData, imgPre)
            $('#' + fileid)
                .parent()
                .find('span')
                .addClass('img-closer-show')
        },
        uploadImg(obj) {
            var imgPre = document.getElementById(obj.imgid)
            if (imgPre.src != this.camera) return
            var input = document.getElementById(obj.fileid)
            input.click()
        },
        deleteImg(index, imgid) {
            var imgIndex
            for (var i = 0; i < $('.img-closer-show').length; i++) {
                if ($('.img-closer-show')[i] == event.target) imgIndex = i
            }
            $(event.target).removeClass('img-closer-show')
            var imgPre = document.getElementById(imgid)
            imgPre.src = this.camera
            this.compressImg.splice(imgIndex, 1)
        },
        compress(imgData, imgPre) {
            var vm = this
            var initSize, height, width, compressData
            var imgCanvas = document.getElementById('compressImg')
            var ctx = imgCanvas.getContext('2d')
            var rate = this.compressRate(imgData.imgSize)
            var img = new Image()
            img.src = imgData.url
            img.onload = function() {
                var Orientation = null
                EXIF.getData(img, function() {
                    //EXIF.getAllTags(this);
                    Orientation = EXIF.getTag(this, 'Orientation')
                    if (Orientation == undefined) {
                        Orientation = 1
                    }
                    //console.info(Orientation)
                    width = img.width
                    height = img.height
                    //console.info(width+' ---- '+height)

                    if (Orientation == 6) {
                        imgCanvas.width = height
                        imgCanvas.height = width
                        ctx.translate(height, 0)
                        ctx.rotate(Math.PI / 2)
                        ctx.drawImage(img, 0, 0, width, height)
                    } else if (Orientation == 8) {
                        imgCanvas.width = height
                        imgCanvas.height = width
                        ctx.translate(0, width)
                        ctx.rotate(-Math.PI / 2)
                        ctx.drawImage(img, 0, 0, width, height)
                    } else if (Orientation == 3) {
                        imgCanvas.width = width
                        imgCanvas.height = height
                        ctx.translate(width, height)
                        ctx.rotate(Math.PI)
                        ctx.drawImage(img, 0, 0, width, height)
                    } else if (Orientation == 1) {
                        imgCanvas.width = width
                        imgCanvas.height = height
                        ctx.drawImage(img, 0, 0, width, height)
                    }

                    //console.info(rate)
                    compressData = imgCanvas.toDataURL('image/jpeg', rate)
                    imgPre.src = compressData
                    //console.info(compressData)
                    compressData = compressData.replace('data:image/jpeg;base64,/', 'data:image/jpeg;base64;/')
                    vm.compressImg.push(compressData)
                })
            }
        },
        compressRate(size) {
            var rate = 0
            if (size <= 400000) {
                rate = 0.3
            } else if (size <= 600000) {
                rate = 0.2
            } else if (size <= 4000000) {
                rate = 0.1
            } else if (size <= 10000000) {
                rate = 0.08
            } else {
                rate = 0.05
            }
            return rate
        },
        getFileUrl(fileid, imgPre) {
            var file = document.getElementById(fileid).files.item(0)
            var imgUrl = window.URL.createObjectURL(file)
            imgPre.src = imgUrl
            var imgSize = file.size
            //console.info(imgSize)
            return {
                url: imgUrl,
                imgSize: imgSize
            }
        },

        showDialog($dialog) {
            $dialog.parent().fadeIn(300)
            if ($dialog.attr('class') === 'submitTip-dialog') {
                return
            }
            $dialog.addClass('dialog-show')
            if ($dialog.hasClass('choice-area-dialog')) {
                if ($sliderBar.width() == 0) {
                    if ($county.hasClass('active')) {
                        $county.trigger('click')
                    } else {
                        $street.trigger('click')
                    }
                }
            }
        },
        closeDialog() {
            $('.submitTip-dialog')
                .parent()
                .fadeOut(300)
            if ($('.submitTip-dialog').attr('class') === 'submitTip-dialog') {
                return
            }
            $('.submitTip-dialog').removeClass('dialog-show')
            if (this.isPass) document.getElementById('backspan').click()
        },
        validateForm() {
            var hasFile = false
            var hasStreet = false
            this.isPass = false
            $('input[name=file]').each(function(index, ele) {
                if ($(ele).val()) {
                    hasFile = true
                }
            })
            if (this.streetName) {
                hasStreet = true
            }
            if (hasFile && hasStreet && this.compressImg.length != 0) {
                this.isPass = true
            } else {
                //var tip;
                if (!hasFile && hasStreet && this.compressImg.length == 0) {
                    this.upLoadTip = '请添加要上传的照片'
                } else if (hasFile && !hasStreet) {
                    this.upLoadTip = '请选择街道'
                } else {
                    this.upLoadTip = '请选择街道和要上传的照片'
                }
                this.upLoadStatus = 'tip'
                this.showDialog($('.submitTip-dialog'))
            }
            return this.isPass
        },
        photographSumbit() {
            //上传
            var vm = this
            var isSubmit = this.validateForm()
            var indexDescription = this.switchLevelIndex(this.piaoxuAcive)
            var formData = {
                streetName: vm.clickPositionObj.street,
                streetLon: vm.clickPositionObj.lng,
                streetLat: vm.clickPositionObj.lat,
                indexDescription: indexDescription,
                cityCode: vm.citycode,
                file: vm.compressImg.join(',')
            }
            var timeout = 5000 * this.compressImg.length
            if (isSubmit) {
                vm.isImgUpLoading = true
                $.ajax({
                    type: 'post',
                    url: vm.basePath + '/user/uploadphoto',
                    cache: false,
                    data: formData,
                    timeout: timeout,
                    dataType: 'json',
                    success: function(res) {
                        vm.isImgUpLoading = false
                        var tip
                        if (res[0].result === 'success') {
                            vm.upLoadTip = '上传图片成功'
                        } else {
                            vm.upLoadTip = '上传图片失败'
                            vm.isPass = false
                        }
                        if (vm.compressImg.length == 0) return
                        vm.upLoadStatus = res[0].result
                        vm.showDialog($('.submitTip-dialog'))
                    },
                    error: function(xhr) {
                        vm.isPass = false
                        vm.isImgUpLoading = false
                        if (vm.compressImg.length == 0) return
                        vm.upLoadTip = '上传图片失败'
                        vm.upLoadStatus = 'fail'
                        vm.showDialog($('.submitTip-dialog'))
                    }
                })
            }
            return false
        },
        selectArea(street) {
            this.hasSelectStreet = true
            this.streetFit = []
            this.streetLon = street.x
            this.streetLat = street.y
            this.upLoadstreetName = street.n
            this.isShowAreaSelect = false
            this.isStreetFitContentShow = false
            var clickPosition = {
                lng: street.x,
                lat: street.y,
                street: street.n
            }
            this.updateParam([
                {
                    clickPositionObj: clickPosition
                }
            ])
        },
        resetPosition(street) {
            this.isLocation = false
            this.streetFit = []
            this.upLoadstreetName = ''
            this.streetName = street.name
            this.showPositionPannel = false
            this.setCookie('FATONG_LONLAT', street.location.lng + ';' + street.location.lat)
            this.updateParam([
                {
                    clickPositionObj: {
                        lng: street.location.lng,
                        lat: street.location.lat,
                        street: street.name
                    }
                }
            ])
            this.getLiveData(street.location.lng, street.location.lat, true)
        },
        is_weixin() {
            var ua = navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true
            } else {
                return false
            }
        },
        getQueryString(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            var r = window.location.search.substr(1).match(reg)
            if (r != null) return unescape(r[2])
            return null
        }
    },
    mounted: function() {
        var vm = this;
        this.culHeght();
        var lnglat = this.initStreesInfo[this.citycode].lnglat;
        var acode = this.initStreesInfo[this.citycode].acode;
        gmap.init('map', lnglat, acode); //初始化地图
        lmap.initmap('leafletmap', lnglat); //初始化地图
        this.$nextTick(() => {
            this.getNewLocation();
        })
        this.addEvent();
        this.eventHandler();
        this.imgHammer();
        //监听resize事件
        window.addEventListener('resize', this.updateOrientation, false);
        $('.userposition_div_img').attr('src', base64Img['userposition_div_img']);
        //    console.log(coordtransform.gcj02towgs84(110.235,32.023))
    },
    destroyed() {}
}
</script>
<style lang="less">
.treeTypeDiv {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 136px;
    z-index: 9999;
    background: #fff;
    border-radius: 3px;
    box-shadow: 1px 0px 4px rgba(0, 0, 0, 0.4);
}

.treeTypeDiv li {
    padding: 5px;
    float: left;
    font-size: 12px;
    color: #38c99e;
    cursor: pointer;
}

.treeTypeDiv li.on {
    color: #fff;
    background: #38c99e;
}

.userposition_div {
    font-size: 14px;
    color: #908f8f;
}

.userposition_div_img {
    width: 16px;
    height: 16px;
    margin-left: 9px;
}

.jump_div {
    font-weight: bold;
    text-align: center;
    margin-top: 1px;
}

.jump_div_ss {
    color: red;
}

// .jump_div_text {
// }

.jump_div_go {
    color: green;
}

.unopenPic {
    background: #d8d8d8 !important;
}

.unopenPic:before {
    opacity: 0.5 !important;
}

.showpoto_div {
    position: fixed !important;
    overflow: auto;
    /*overflow: hidden;
    	left: 0px;
		*/
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 9999;
}

.streetnameSpan {
    position: absolute;
    display: inline-block;
    width: 20px;
    height: 20px;
    top: 1px;
    right: 3px;
    background: url('data:image/png;charset=utf-8;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAIVBMVEUAAABHuJVHuJVHuJVHuJVHuJVHuJVHuJVHuJVHuJVHuJUgoCdPAAAACnRSTlMAEM9g7zBAn3BQmGzdRAAAAEtJREFUCNdjAAPOAAYIsHKF0MyrlgRABFatcoUIrFq1BCqwahFUYJUiTEAAiwCDFlRAUAgqkCSoBRZgyFIUAgqAGIsEC8H2dEEkGAB8Fx9ESztdNwAAAABJRU5ErkJggg==') no-repeat center left;
}

.picture_div {
    float: left;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #000;
}

.swiper-container {
    position: absolute;
    top: 46%;
    left: 0;
    width: 100%;
    height: 50%;
    overflow: auto;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    .swiper-wrapper {
        /*width: 100%;*/
        height: 100%;
    }
    .swiper-slide {
        background-position: 50%;
        background-size: cover;
        background-color: #000;
        border: #000 1px solid;
        height: 100%;
        text-align: center;
        img {
            width: auto;
            height: 100%;
        }
    }
    .swiper-pagination-bullet {
        width: 0.833rem;
        height: 0.833rem;
        display: inline-block;
        background: #7c5e53;
    }
}

.piaoxuLevel {
    position: absolute;
    bottom: 18%;
    color: #fff;
}

.piaoxuLevel .piaoxuLevel-title:before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 28px;
    vertical-align: middle;
}

.image-list {
    position: absolute;
    left: 0px;
    bottom: 1%;
    width: 100%;
    height: 12%;
    overflow: hidden;
    div {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    ul {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        position: absolute;
        left: 0;
        height: 100%;
        .footdiv {
            float: left;
            position: relative;
            width: 60px;
            height: 60px;
            margin: 0px 5px;
            border: #999 solid 1px;
            background-repeat: no-repeat;
            -webkit-background-size: auto 100% !important;
            background-size: auto 100% !important;
            background-position: center !important;
        }
        .footdiv_active {
            border: 2px solid #39ded6;
        }
    }
}

.backspan {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 54px;
    height: 54px;
    z-index: 101;
}

.backspan:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    margin-left: -6px;
    margin-top: -6px;
    border-left: 4px solid rgb(56, 201, 160);
    border-bottom: 4px solid rgb(56, 201, 160);
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}

.loader {
    height: 100% !important;
    /*padding-top: 50%;*/
    background-color: rgba(0, 0, 0, 0.4);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -ms-flex-preferred-size: 25%;
    flex-basis: 25%;
    width: 100%;
    height: 200px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 100;
}

.ball-spin-fade-loader {
    margin-left: -5%;
}

.loadText {
    color: #fff;
    margin-top: 50px;
}

.loadTip {
    color: #fff;
    margin-top: 200px;
    text-align: center;
    font-size: 16px;
}

.streetFitContent {
    position: fixed;
    top: 0px;
    height: 100%;
    width: 100%;
    background-color: #fff;
    z-index: 10;
}

.streetFitContent ul {
    height: 100%;
    overflow: auto;
}

.streetFitContent ul li {
    list-style: none;
    line-height: 44px;
    padding-left: 35px;
    font-size: 15px;
    border-bottom: solid 1px #e1e0e6;
}

.streetFitContent div {
    height: 44px;
    line-height: 44px;
    padding-left: 35px;
    font-size: 16px;
    color: #999;
}

.BigImgCont {
    position: relative;
    height: 100%;
    width: 100%;
    color: #fff;
    background-color: #000;
    overflow: auto;
    z-index: 10000;
}

.BigImgCont img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.positionPannel {
    height: 100%;
    width: 100%;
}

.position {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 54px;
    background: #efecec;
    z-index: 11;
}

.position input {
    display: block;
    outline: none;
    border-radius: 30px;
    height: 30px;
    width: 67%;
    line-height: 30px;
    margin: 12px auto;
    padding-left: 16px;
    border: 1px solid #37c79d;
}

.mapcontain {
    width: 100%;
    height: 100%;
    position: absolute;
}

.imgLoadingSpan {
    position: absolute;
    top: 0px;
    display: inline-block;
    height: 100%;
    width: 100%;
    background: url(./images/loading.gif) center no-repeat;
    z-index: 1;
}

.loading {
    animation-name: loading;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-play-state: running;
    /* Safari and Chrome: */
    -webkit-animation-name: loading;
    -webkit-animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-play-state: running;
}

@keyframes loading {
    0% {
        transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
    }
    25% {
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
    }
    50% {
        transform: rotate(270deg);
        -ms-transform: rotate(270deg);
        -webkit-transform: rotate(270deg);
    }
    100% {
        transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
    }
}

@-webkit-keyframes loading {
    0% {
        transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
    }
    25% {
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
    }
    50% {
        transform: rotate(270deg);
        -ms-transform: rotate(270deg);
        -webkit-transform: rotate(270deg);
    }
    100% {
        transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
    }
}

.photo_divs {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
}

.stree_label {
    float: right;
    margin-right: 15px;
    font-size: 15px;
    color: #807e7e;
}
</style>



// WEBPACK FOOTER //
// src/components/content/home/home_gd1.vue